module.exports = __webpack_public_path__ + "static/media/AccountPastOrdersScreen.516e504e.png";